const calcTextSize = (
    text: HTMLElement,
    widthBasis: number,
    setFontSize: (fontSize: string) => void,
    maxTextGrowth: number,
    minFontSize?: number
): void => {
    const currentTextWidth = text.scrollWidth;
    const currentFontSize = text.style && text.style.fontSize;
    if (currentFontSize && currentTextWidth && widthBasis) {
        const fontSizeToNumber = parseInt(currentFontSize, 10);
        const maxSize = maxTextGrowth ? fontSizeToNumber * maxTextGrowth : 500;
        const newValue = Math.min(
            Math.max(minFontSize || 16, (widthBasis / currentTextWidth) * fontSizeToNumber),
            maxSize
        );
        setFontSize(`${newValue}px`);
    }
};

export default calcTextSize;

export const getParentSize = (
    text: HTMLElement
): {
    parentWidth: number;
    textHeight: number;
    parentHeight: number;
} => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const parentWidth = text?.parentNode?.clientWidth;
    const textHeight = text.scrollHeight;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const parentHeight = text?.parentNode?.clientHeight;
    return {
        parentWidth,
        textHeight,
        parentHeight,
    };
};
